import { createContext } from 'react'
import { CopilotUploadPreset } from 'shared/types/copilot'

export type CopilotContextProps = {
    activePresetId?: string
    disabled: boolean
    hasChanges: boolean
    presets: CopilotUploadPreset[]
    importedPresets: CopilotUploadPreset[]
    activatePreset: (presetId: string) => void
    copyPresetToClipboard: (presetId: string) => void
    getActivePreset: () => CopilotUploadPreset | null
    getPresetById: (id: string) => CopilotUploadPreset | null
    removePresetById: (id: string) => void
    resetPreset: () => void
}

export const CopilotContext = createContext({} as CopilotContextProps)
